import React, { useState } from 'react';
import logo from '../assets/images/Saha Logo_nobg.png'

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  // Function to handle smooth scrolling
  const scrollToSection = (section) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close navbar after clicking a link (for mobile view)
    setIsNavOpen(false);
  };

  return (
    <div id="navbar">
      {/* Top Bar */}
      <div>
      <header className="top-bar">
        <div className="container d-flex justify-content-between align-items-center py-2">
          <div className="text-white ml-5"> info@sahainfotechs.com</div>
          <div className="d-flex">          
           
                          <a href="#" ><i className="fab fa-facebook-f" style={{color:'#48c7ec',marginRight:'10px'}}></i></a>                        
                          <a href="#" className="ms-2"><i className="fab fa-linkedin-in" style={{color:'#48c7ec',marginRight:'10px'}}></i></a>                    
                          <a href="#" className="ms-2"><i className="fab fa-twitter" style={{color:'#48c7ec',marginRight:'10px'}}></i></a>
           
          </div>
        </div>
      </header>
      </div>
      {/* Navigation Section */}
     
      <nav className="navbar navbar-expand-lg navbar-light bg-light d-flex">
  <div className="container">
    {/* Logo shifted to the left using 'me-auto' */}
    <a className="navbar-brand me-auto" href="#">
      <img className="img-fluid" style={{ padding: '25px', height: '130px' }} src={logo} alt="Brand Logo" />
    </a>

    <button
      className="navbar-toggler"
      type="button"
      onClick={() => setIsNavOpen(!isNavOpen)}
      aria-expanded={isNavOpen}
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    {/* Menu shifted to the right using 'ms-auto' */}
    <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNavDropdown">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item">
          <a className="nav-link active" href="/#Home">
            HOME
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/#About" onClick={() => scrollToSection('About')}>
            ABOUT US
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/#Services" onClick={() => scrollToSection('Services')}>
            SERVICES
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/#Contact" onClick={() => scrollToSection('Contact')}>
            CONTACT US
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

      </div>
  
  );
};

export default Navbar;
